import React, { useContext } from 'react';
import { Provider } from 'react-redux';
/* eslint-disable */
import Store from 'redux/store';
import { OidcProvider } from 'redux-oidc';
import userManager from '@/Shared/Auth/UserManager/userManager';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { LastLocationProvider } from 'react-router-dom-last-location';
import history from 'redux/history';
import { BrowserRouter } from 'react-router-dom';
import CategoryPageProvider from '../../pages/CategoryPage/CategoryPageProvider';
import StoresSearchProvider from '../../pages/StoresSearchPage/StoresSearchProvider';
import SearchProvider from '../../pages/SearchPage/SearchProvider';
import ScrollToTop from 'Shared/ScrollToTop/ScrollToTop';
import RootLoading from '../../Services/Providers/RootLoading';
import { FooterDefault } from '../index';
import HeaderRoutes from '../header/headerRoutes';
import NotificationProvider from '../../Shared/Notification';
import TagManagerWidget from 'Shared/Widgets/TagManagerWidget';
import { HierarchyProductsLocalStorageProvider } from 'Context/HierarchyLocalStorageContext';
import { SimulationLocalStorageProvider } from 'Context/SimulationLocalSotrageContext';
import ShowcaseProvider from '../../pages/Showcase/ShowcaseProvider';
import { Helmet } from 'react-helmet';
import Widgets from 'Shared/Widgets';
import HeaderWallInvisible from 'structure/header/HeaderWall';
import HeaderWallInvisibleMobile from 'structure/header/HeaderWallMobile';

import ChatbotProvider from '../../components/Chatbot/ChatboxProvider';
import { InitChat } from '../../components/Chatbot';
import { VertTokens } from '@vertem-core/vertice-ds';
import RatingProvider from 'components/RatingProducts/Provider';
import GiftPermissions from 'components/GiftPermissions';
import WishListProvider from 'Context/Wishlist';

const RootProvider = ({ children }) => {
  const { designTokens } = useContext(VertTokens);
  const { favicon: Favicon } = designTokens;

  return (
    <RootLoading>
      <Provider store={Store}>
        <HierarchyProductsLocalStorageProvider>
          <SimulationLocalStorageProvider>
            <OidcProvider store={Store} userManager={userManager}>
              <BrowserRouter>
                <ScrollToTop />
                <LastLocationProvider>
                  <ConnectedRouter omitRouter history={history}>
                    <CategoryPageProvider>
                      <StoresSearchProvider>
                        <SearchProvider>
                          <ChatbotProvider>
                            <ShowcaseProvider>
                              <NotificationProvider>
                                <RatingProvider>
                                  <GiftPermissions>
                                    <WishListProvider>
                                      <InitChat />
                                      <Helmet>
                                        <link rel='icon' href={Favicon} />
                                      </Helmet>
                                      <HeaderRoutes />
                                      {process.env.REACT_HEADER_FIXED
                                        ? <HeaderWallInvisible /> && <HeaderWallInvisibleMobile />
                                        : null}
                                      <>{children}</>
                                      <FooterDefault />
                                      <TagManagerWidget />
                                      <Widgets />
                                    </WishListProvider>
                                  </GiftPermissions>
                                </RatingProvider>
                              </NotificationProvider>
                            </ShowcaseProvider>
                          </ChatbotProvider>
                        </SearchProvider>
                      </StoresSearchProvider>
                    </CategoryPageProvider>
                  </ConnectedRouter>
                </LastLocationProvider>
              </BrowserRouter>
            </OidcProvider>
          </SimulationLocalStorageProvider>
        </HierarchyProductsLocalStorageProvider>
      </Provider>
    </RootLoading>
  );
};

RootProvider.propTypes = {
  children: PropTypes.node,
};

export default RootProvider;
